import { Injectable, Optional } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { icons } from './config';

export class IconRegistryConfig {
  path!: string;
}

@Injectable()
export class IconRegistryService {
  path!: string;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    @Optional() config?: IconRegistryConfig
  ) {
    this.path = config ? config.path : '/assets/icons';
  }

  registerIcons() {
    icons.forEach((icon) => {
      this.matIconRegistry.addSvgIcon(
        icon.name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `${this.path}/${icon.filename}`
        )
      );
    });
  }
}
